module.exports = __webpack_public_path__ + "img/il_erro_404.59344a6b.svg";